import { Typography } from '@mui/material';
import { ChallengeBarContainer } from './challenge-bar';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChallengeBarError = function ChallengeBarError(_ref) {
  var isMobile = _ref.isMobile;
  return /*#__PURE__*/_jsx(ChallengeBarContainer, {
    "data-element": "ChallengeBarContainer",
    "data-component": "ChallengeBarError",
    "data-source-file": "challenge-bar-error.tsx",
    children: /*#__PURE__*/_jsx(Typography, {
      variant: isMobile ? 'body2' : 'body1',
      "data-element": "Typography",
      "data-component": "ChallengeBarError",
      "data-source-file": "challenge-bar-error.tsx",
      children: "Unable to load challenge information."
    })
  });
};